import { mmFetchWithResponse } from '../mmFetchWithResponse';

const baseUrl = 'api/fbm/v3/orders';

const fbmOrdersV3 = {
    getDeepDive: async (orderNum, fbmAccountName) => {
        const url = `${baseUrl}/deep-dive?orderNum=${encodeURIComponent(orderNum)}&fbmAccount=${fbmAccountName}`;
        return mmFetchWithResponse(url, { method: 'GET' });
    },
    cancelPartnerOrder: async (orderNum, fbmAccountName, reason) => {
        const url = `${baseUrl}/partner-order/cancel?fbmAccount=${encodeURIComponent(fbmAccountName)}`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({
                orderNum,
                reason,
            }),
        });
    },
};

export { fbmOrdersV3 };
